import Chart from 'chart.js';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import PerimetreContext from '../../contexts/PerimetreContext';
import { DataAlarme } from '../../data/DataAlarme';
import { Immocom } from '../../specifique/immocom';
import { ChartModele } from './ChartModele';

export class ChartQueuesDeProgramme extends Component {

    static contextType = PerimetreContext;

    static defaultState = {
        afficheMessagePasDeDonnees: false,
        chargementEnCours: false,
        chartEnCours: null,
        redirect: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...ChartQueuesDeProgramme.defaultState };
    };

    _chargementDonnees = () => {

        this.setState({
            chargementEnCours: true,
            afficheMessagePasDeDonnees: false
        });

        DataAlarme._chargementQueuesDeProgrammes().then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const objetData = responseFetch.reponseAPIobjet;

                let legendes = [];
                let valeurs = [];
                let couleurs = [];
                let couleursSurvol = [];
                let listeIdOperation = [];
                let listeIdAgence = [];
                let listeIdRegion = [];
                let listeIdRegionAdministrative = [];
                let listeIdDepartementAdministratif = [];
                let listeIdVilleAdministrative = [];

                if (objetData.length > 0) {
                    objetData.map(reservation => {
                        const { couleurPrincipale, couleurSurvol, idAgence, idDepartementAdministratif, idOperation, idRegion, idRegionAdministrative, idVilleAdministrative, nbLotsDispo, nomCommercial } = reservation;
                        legendes.push(nomCommercial);
                        valeurs.push(nbLotsDispo);
                        couleurs.push(couleurPrincipale);
                        couleursSurvol.push(couleurSurvol);
                        listeIdOperation.push(idOperation);
                        listeIdAgence.push(idAgence);
                        listeIdRegion.push(idRegion);
                        listeIdRegionAdministrative.push(idRegionAdministrative);
                        listeIdDepartementAdministratif.push(idDepartementAdministratif);
                        listeIdVilleAdministrative.push(idVilleAdministrative);
                    });

                    var graphiqueQueuesDeProgramme = new Chart(
                        "GraphiqueQueuesDeProgramme",
                        {
                            type: "horizontalBar",
                            data: {
                                labels: legendes,
                                datasets: [{
                                    label: 'Nombre de lots disponibles',
                                    data: valeurs,
                                    backgroundColor: couleurs,
                                    hoverBackgroundColor: couleursSurvol,
                                    IdOperation: listeIdOperation,
                                    IdAgence: listeIdAgence,
                                    IdRegion: listeIdRegion,
                                    IdRegionAdministrative: listeIdRegionAdministrative,
                                    IdDepartementAdministratif: listeIdDepartementAdministratif,
                                    IdVilleAdministrative: listeIdVilleAdministrative
                                }]
                            },
                            options: {
                                "scales": {
                                    "xAxes": [{
                                        "ticks": {
                                            "beginAtZero": true,
                                            "stepSize": 1
                                        }
                                    }]
                                },
                                "onClick": (evt, item) => {
                                    if (item.length > 0) {
                                        const element = item[0];
                                        const index = element._index;
                                        const idOperation = parseInt(element._chart.data.datasets[0].IdOperation[index]);
                                        const idAgence = parseInt(element._chart.data.datasets[0].IdAgence[index]);
                                        const idRegion = parseInt(element._chart.data.datasets[0].IdRegion[index]);
                                        const idRegionAdministrative = parseInt(element._chart.data.datasets[0].IdRegionAdministrative[index]);
                                        const idDepartementAdministratif = element._chart.data.datasets[0].IdDepartementAdministratif[index];
                                        const idVilleAdministrative = element._chart.data.datasets[0].IdVilleAdministrative[index];

                                        const { setPerimetre } = this.context;
                                        const perimetre = { idRegion, idAgence, idRegionAdministrative, idDepartementAdministratif, idVilleAdministrative, idOperation };
                                        console.log(perimetre)
                                        const onSuccess = () => {
                                            localStorage.setItem('filtreDisponible', true);
                                            localStorage.setItem('filtreReserve', false);
                                            localStorage.setItem('filtreOptionne', false);
                                            this.setState({ redirect: true });
                                        };
                                        setPerimetre(perimetre, onSuccess);
                                    }
                                }
                            }
                        });

                    this.setState({
                        chargementEnCours: false,
                        chartEnCours: graphiqueQueuesDeProgramme
                    });
                }
                else {
                    this.setState({
                        afficheMessagePasDeDonnees: true,
                        chargementEnCours: false
                    });
                }
            }
            else {
                const state = {
                    chargementEnCours: false,
                    chartEnCours: null
                };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });

    };

    _onRechargement = () => {
        if (this.state.chartEnCours !== null)
            this.state.chartEnCours.destroy();

        this._chargementDonnees();
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {
        const { afficheMessagePasDeDonnees, chargementEnCours, redirect } = this.state;

        if (redirect) {
            return <Redirect to='/Vente/EspaceDeVente/V/1' />;
        } else {
            return <ChartModele
                afficheMessagePasDeDonnees={afficheMessagePasDeDonnees}
                chargementEnCours={chargementEnCours}
                idChart="GraphiqueQueuesDeProgramme"
                titre="Queues de programmes"
            />;
        }
    };

};